import { dateFormat } from '@/helpers/dateHelper'

let formatters = {}

function getCurrencyFormatter() {
    formatters.currency = formatters.currency || new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })

    return formatters.currency
}

export default {
    entityHtml (html) {
        if (typeof html === 'string') {
            html = html.replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;')
        }

        return html
    },

    camelize(str) {
        return str.replace(/\W+(.)/g, (match, chr) => chr.toUpperCase())
    },

    highlightText(text, highlight) {
        let foundIdx = text.toLowerCase().indexOf(highlight)

        if (foundIdx >= 0) {
            text = text.substring(0, foundIdx) +
                `<b>${text.substring(foundIdx, foundIdx + highlight.length)}</b>` +
                text.substring(foundIdx + highlight.length, text.length)
        }

        return text
    },

    avatarLetters(name) {
        if(!name) return name

        let words = name.split(' ', 2)

        if (words.length <= 1) {
            return (words[0].charAt(0) + words[0].charAt(1)).toUpperCase()
        }

        return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase()
    },

    dateRangeFilter(key, object) {
        if (!object || !object[key]) {
            return
        }

        let dates = object[key].split(' - ', 2)

        if (dates.length < 2) {
            return;
        }

        const from = dates[0].trim()
        const to = dates[1].trim()
        const placeholder = dateFormat().placeholder.date

        if (from !== placeholder) {
            object[key + '_from'] = {
                value: from + ' 00:00:00',
                operator: '>=',
                column: key
            }
        }

        if (to !== placeholder) {
            object[key + '_to'] = {
                value: to + ' 23:59:59',
                operator: '<=',
                column: key
            }
        }

        delete object[key]
    },

    periodRangeFilter(object, key = 'period') {
        if (!object || !object[key]) {
            return
        }

        let dates = object[key].split(' - ', 2)

        if (dates.length < 2) {
            return
        }

        object[key] = {
            start: dates[0].trim() + ' 00:00:00',
            end: dates[1].trim() + ' 23:59:59'
        }
    },

    textPrice(price) {
        return getCurrencyFormatter().format(price)
    }
}
